export default {
  'icon-1': `<img
                src="/icons/rail-monsters.svg"
                alt=""
                class="section-about__icon section-about__icon--monsters"
              />`,
  'icon-2': `<img
                src="/icons/train.svg"
                alt=""
                class="section-about__icon section-about__icon--train"
              />`,
  'icon-3': `<img
                src="/icons/asia.svg"
                alt=""
                class="section-about__icon section-about__icon--asia"
              />`,
  'icon-4': `<img
                src="/icons/middle-east.svg"
                alt=""
                class="section-about__icon section-about__icon--middle-east"
              />`,
  'icon-5': `<img
                src="/icons/worldwide.svg"
                alt=""
                class="section-about__icon section-about__icon--worldwide"
              />`,
};
